// extracted by mini-css-extract-plugin
module.exports = {"btnFooter":"btnFooter--bCvuT","btnPosition":"btnPosition--AfMm0","serverSetBtn":"serverSetBtn--_f_xC","serverSetPrimaryBtn":"serverSetPrimaryBtn--iB2Fk"};